import {request, getCompanyId} from '../utils';
import {
  API_EMPLOYEE_REGISTRATION,
  API_DELETE_BULK,
  API_FAMILY_REGISTRATION,
  API_MARK_DELETE,
  API_MARK_UNDO,
  API_SEARCH_EMPLOYEES,
  API_UPDATE_EMPLOYEE,
  API_FETCH_RECENT_UPLOADS,
  API_FETCH_DEACTIVATE_RECENT_UPLOADS,
  API_UPLOAD_FILE_STATUS,
  API_DEACTIVATE_UPLOAD_FILE_STATUS,
  API_RECENT_UPLOAD_DETAILS,
  API_DEACTIVATE_RECENT_UPLOAD_DETAILS,
  API_FETCH_FAMILY_MEMBERS,
  API_UPDATE_FAMILY_MEMBERS,
  API_FETCH_ENTITY_DETAILS,
  API_FOR_MANAGE_EMPLOYEE_METRIC_CARD,
  API_FOR_BULK_DEACTIVATE_EMPLOYEES,
  API_FOR_ACTIVATE_EMPLOYEES,
  API_ADD_EMPLOYEE,
  API_FOR_DOWNLOAD_EMPLOYEE_LIST,
  //pre-employee
  API_PRE_EMP_BUSINESS_UNIT,
  API_PRE_EMP_CHECK_UP,
  API_PRE_EMP_BULK_UPLOAD,
  API_PRE_EMP_UPLOAD_STATUS,
  API_PRE_EMP_RECENT_UPLOAD,
  API_PRE_EMP_RECENT_UPLOAD_DETAILS,
  DOWNLOAD_RECENT_PRE_EMP_UPLOAD,
  API_UPDATE_APPT_REQ,
  FETCH_TOTAL_RECORDS,
  FETCH_PRE_EMP_RECORDS_API,
  DOWNLOAD_PRE_EMP_REPORTS,
  DOWNLOAD_PRE_EMP_VOUCHER,
  FETCH_PROVIDERS_DETAILS,
  FETCH_ENTERPRISE_DETAILS,
  RESCHEDULE_APPOINTMENT,
  UPLOAD_CSV_FILE,
  DOWNLOAD_CSV_FILE,
  API_COMPANY_GRADES,
  FETCH_CALL_RECORDINGS
} from '../routes/api';

class employeeDataApi {
  static register_employees(options, onSuccess, onError) {
    return request({ url: API_EMPLOYEE_REGISTRATION, method: 'post', ...options }, onSuccess, onError);
  }

  static register_family_members(options, onSuccess, onError) {
    return request({ url: API_FAMILY_REGISTRATION, method: 'post', ...options }, onSuccess, onError);
  }

  static company_grades(options, onSuccess, onError) {
    return request({ url: API_COMPANY_GRADES(options.companyId), method: 'get', ...options }, onSuccess, onError);
  }

  static delete_employees(options, onSuccess, onError) {
    return request({ url: API_DELETE_BULK, method: 'post', ...options }, onSuccess, onError);
  }

  static delete(options, onSuccess, onError) {
    return request({ url: API_MARK_DELETE(options.id) }, onSuccess, onError);
  }

  static undo(options, onSuccess, onError) {
    return request({ url: API_MARK_UNDO(options.id) }, onSuccess, onError);
  }

  static search_employees(options, onSuccess, onError) {
    return request({ url: API_SEARCH_EMPLOYEES + '?' + getCompanyId(true), ...options }, onSuccess, onError);
  }

  static update_employees(options, onSuccess, onError) {
    return request({ url: API_UPDATE_EMPLOYEE(options.id), method: 'put', ...options }, onSuccess, onError);
  }

  static upload_status(options, onSuccess, onError) {
    return request({ url: API_UPLOAD_FILE_STATUS(options.id), ...options }, onSuccess, onError);
  }

  static deactivate_upload_status(options, onSuccess, onError) {
    return request({ url: API_DEACTIVATE_UPLOAD_FILE_STATUS(options.id), ...options }, onSuccess, onError);
  }

  static fetch_recent_uploads(options, onSuccess, onError) {
    return request({ url: API_FETCH_RECENT_UPLOADS(options.type), ...options }, onSuccess, onError);
  }

  static fetch_deactivate_recent_uploads(options, onSuccess, onError) {
    return request({ url: API_FETCH_DEACTIVATE_RECENT_UPLOADS, ...options }, onSuccess, onError);
  }

  static recent_uploads_details(options, onSuccess, onError) {
    return request({ url: API_RECENT_UPLOAD_DETAILS(options.id, options.page), ...options }, onSuccess, onError);
  }

  static deactivate_recent_uploads_details(options, onSuccess, onError) {
    return request({ url: API_DEACTIVATE_RECENT_UPLOAD_DETAILS(options.id, options.page), ...options }, onSuccess, onError);
  }

  static fetch_family_members(options, onSuccess, onError) {
    return request({ url: API_FETCH_FAMILY_MEMBERS(options.id), ...options }, onSuccess, onError);
  }

  static update_family_member(options, onSuccess, onError) {
    return request({ url: API_UPDATE_FAMILY_MEMBERS(options.id), method: 'put', ...options }, onSuccess, onError);
  }
  
  static fetch_entity_details(options, onSuccess, onError) {
    return request({ url: API_FETCH_ENTITY_DETAILS(options.id) + '?' + getCompanyId(true), method: 'get', ...options }, onSuccess, onError);
  }
  
  static fetch_manage_employee_metric_card(options, onSuccess, onError) {
    return request({ url: API_FOR_MANAGE_EMPLOYEE_METRIC_CARD  + '?' + getCompanyId(), method: 'get', ...options }, onSuccess, onError);
  }
  
  static deactivate_bulk_employees(options, onSuccess, onError) {
    return request({ url: API_FOR_BULK_DEACTIVATE_EMPLOYEES, method: 'put', ...options }, onSuccess, onError);
  }

  static activate_employees(options, onSuccess, onError) {
    return request({ url: API_FOR_ACTIVATE_EMPLOYEES(options.id), method: 'put', ...options }, onSuccess, onError);
  }

  static add_employee(options, onSuccess, onError) {
    return request({ url: API_ADD_EMPLOYEE + '?' + getCompanyId(), method: 'post', ...options }, onSuccess, onError);
  }

  static download_employee_list(options, onSuccess, onError) {
    return request({ url: API_FOR_DOWNLOAD_EMPLOYEE_LIST + '?' + getCompanyId(true), method: 'get', ...options }, onSuccess, onError);
  }

  //pre-employment Api's

  static preEmp_bulk_upload(options, onSuccess, onError) {
    return request({ url: API_PRE_EMP_BULK_UPLOAD, method: 'post', ...options }, onSuccess, onError);
  }

  static preEmp_upload_status(options, onSuccess, onError) {
    return request({ url: API_PRE_EMP_UPLOAD_STATUS(options.id), ...options }, onSuccess, onError);
  }

  static pre_emp_business_unit(options, onSuccess, onError) {
    return request({ url: API_PRE_EMP_BUSINESS_UNIT(options.companyId), method: 'get', ...options}, onSuccess, onError)
  }

  static pre_emp_check_up(options, onSuccess, onError) {
    return request({ url: API_PRE_EMP_CHECK_UP, method: 'post', ...options}, onSuccess, onError)
  }

  static pre_emp_recent_upload(options, onSuccess, onError) {
    return request({ url: API_PRE_EMP_RECENT_UPLOAD(options.type), method: 'get', ...options }, onSuccess, onError)
  }

  static pre_emp_recent_uploads_details(options, onSuccess, onError) {
    return request({ url: API_PRE_EMP_RECENT_UPLOAD_DETAILS(options.id, options.page), ...options }, onSuccess, onError);
  }

  static download_recent_pre_emp_upload(options, onSuccess, onError) {
    return request({ url: DOWNLOAD_RECENT_PRE_EMP_UPLOAD(options.id, options.type), ...options }, onSuccess, onError);
  }

  static pre_emp_update_apptReq(options, onSuccess, onError) {
    return request({ url: API_UPDATE_APPT_REQ, method: 'post', ...options}, onSuccess, onError)
  }

  static fetch_pre_emp_total_records(options, onSuccess, onError) {
    return request({ url: FETCH_TOTAL_RECORDS(options.companyId, options.type), method: 'get', ...options }, onSuccess, onError)
  }

  static fetch_pre_emp_records(options, onSuccess, onError) {
    return request({ url: FETCH_PRE_EMP_RECORDS_API, method: 'get', ...options }, onSuccess, onError)
  }

  static download_pre_emp_voucher(options, onSuccess, onError) {
    return request({ url: DOWNLOAD_PRE_EMP_VOUCHER + '?' + getCompanyId(true) , method: 'get', ...options }, onSuccess, onError)
  }

  static download_pre_emp_reports(options, onSuccess, onError) {
    return request({ url: DOWNLOAD_PRE_EMP_REPORTS(options.id) + '?' + getCompanyId(true), method: 'get', ...options }, onSuccess, onError)
  }

  static fetch_providers(options, onSuccess, onError) {
    return request({ url: FETCH_PROVIDERS_DETAILS( options.customerId,
                                                   options.appointmentId,
                                                   options.enterpriseId,
                                                   options.pincode) + '&' + getCompanyId(true), 
                                                  method: 'get', ...options }, onSuccess, onError)
  }

  static fetch_enterprise(options, onSuccess, onError) {
    return request({ url: FETCH_ENTERPRISE_DETAILS(options.appointmentee_id,
                                                   options.id) + '&' + getCompanyId(true), method: 'get', ...options }, onSuccess, onError)
  }

  static reschedule_appointment(options, onSuccess, onError) {
    return request({ url: RESCHEDULE_APPOINTMENT, method: 'post', ...options}, onSuccess, onError)
  }

  static upload_pre_emp_csv(options, onSuccess, onError) {
    return request({ url: UPLOAD_CSV_FILE, method: 'post', ...options }, onSuccess, onError)
  }

  static download_pre_emp_csv(options, onSuccess, onError) {
    return request({ url: DOWNLOAD_CSV_FILE(options.type) + '&' + getCompanyId(true), method: 'get', ...options }, onSuccess, onError)
  }

  static fetch_call_recordings(options, onSuccess, onError) {
    return request({ url: FETCH_CALL_RECORDINGS(options.id), method: 'get', ...options }, onSuccess, onError)
  }
}

export default employeeDataApi;
